import { color } from '../../../resources/color';

export const getClaimStatusTextColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.blueFocus;
    case 'WAIT_PAYMENT':
      return color.blueFocus;
    case 'PREPARING':
      return color.blueFocus;
    case 'TRANSPORTED':
      return color.blueFocus;
    case 'REJECTED':
      return color.red;
    case 'BOOKING_EXPIRED':
      return color.red;
    default:
      return color.gray;
  }
};

export const getClaimStatusBgColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.light_blue;
    case 'WAIT_PAYMENT':
      return color.light_blue;
    case 'PREPARING':
      return color.light_blue;
    case 'TRANSPORTED':
      return color.bg_blue;
    case 'REJECTED':
      return color.bg_red;
    case 'BOOKING_EXPIRED':
      return color.bg_gray;
    default:
      return color.bg_gray;
  }
};

export const getExpCoupon = (type) => {
  return type === 'BIRTHDAY' ? 'เฉพาะในเดือนเกิด' : 'ตลอดอายุการเป็นสมาชิก 1 ปี';
};
